import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '@follosoft/react-components';
import type { PayPayload } from '@/app/_checkout/types';

export function usePayInvoiceService(invoice: string) {
  return useMutation<void, Error, PayPayload>({
    mutationFn: async (payload) => {
      // Backend expects data.attributes.payment_method_id as an integer
      // (InvoicePayData maps `data.attributes.payment_method_id`). Saved-card
      // ids come back as strings, so coerce to a number.
      await axiosInstance().post(`/account/invoices/${invoice}/pay`, {
        data: {
          attributes: {
            payment_method_id: Number(payload.payment_method_id),
          },
        },
      });
    },
  });
}
